import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import { AlertService, CityService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { EncryptionService } from "../_services/encryption.service";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class City {
  id: number;
  city_name: string;
  state_id: number;
  state_name: string;
  country_id: number;
  country_name: string;
  created_by_name: string;
  created_at: string;
  is_active: string;
}

@Component({
  selector: "app-city",
  templateUrl: "./city.component.html",
})
export class CityComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtOptions: DataTables.Settings = {}; 
  dtTrigger = new Subject(); 
  dtElement: DataTableDirective;
  cityList: City[] = []; 
  cityListTotal : any

  isSubmitted = false;
  getCity = {
    id: "",
    city_name: "",
    state_id: "",
    country_id: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;
  cntry = {};
  stat = {};
  start: number = 0;
  pageLength: number = 10;
  constructor(
    public router: Router,
    private dataService: CityService,
    private alertService: AlertService,
    private AppService: AppService,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private modalService: NgbModal,
  ) {}
  city = {
    id: "",
    city_name: "",
    state_id: "",
    country_id: "",
    is_active: "Y",
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.getCityList();
    this.dataService
      .getAllCountry()
      .pipe()
      .subscribe((data) => {
        this.cntry = data["country"];
      });
    this.dataService
      .getAllState()
      .pipe()
      .subscribe((data) => {
        this.stat = data["state"];
      });
  }

  
  getRowNumber(index: number): number {
    return this.start + index + 1;
  }
  
  
  getCityList() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/all-city-datatable",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters)),
              ),
            },
            {},
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            
            this.cityList = resp.data;
            this.cityListTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "city_name" },
        { data: "state_name" },
        { data: "country_name" },
        { data: "created_at" },
        { data: "is_active" },
      ],
    };
  }

  // allCity() {
  //   this.loadShow();
  //   this.dataService
  //     .getAllCity()
  //     .pipe()
  //     .subscribe((data) => {
  //       this.cityList = data["city"];
  //       this.rerender();
  //       this.loadHide();
  //     });
  // }

  selectStateById(id) {
    this.dataService
      .getStateById(id)
      .pipe()
      .subscribe((data) => {
        this.stat = data["state"];
      });
  }

  open(content) {
    this.isSubmitted = false;
    this.city.id = "";
    ((this.city.city_name = ""),
      (this.city.state_id = ""),
      (this.city.country_id = ""));
    this.city.is_active = "Y";
    this.modalTitle = "Add City";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .getCity(id)
      .pipe()
      .subscribe((data) => {
        this.getCity = data["city"];
        this.selectStateById(this.getCity.country_id);

        this.city = {
          id: this.getCity.id,
          country_id: this.getCity.country_id,
          city_name: this.getCity.city_name,
          state_id: this.getCity.state_id,
          is_active: this.getCity.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit City";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  save(val, f) {
    this.isSubmitted = true;
    if (this.isFieldsInvalid(this.city.city_name)) {
      return;
    }
    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.city)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success("City saved successfully", true);
               const table = $("#city_tab").DataTable();
            table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      } else {
        this.dataService
          .cityUpdate(this.city)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success("City updated successfully", true);
               const table = $("#city_tab").DataTable();
            table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      }
    }
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .cityDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("City deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
             const table = $("#city_tab").DataTable();
            table.ajax.reload(null, false);
          } else {
            this.alertService.error("City error");
          }
        },
        (error) => {
          this.alertService.error(error);
        },
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
